module.exports = __webpack_public_path__ + "static/media/profile-img.00638082.svg";